"use client";

import { Zap, Shield, Cpu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KeyFeatures() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: Zap,
    title: "Lightning Fast",
    description: "Experience blazing-fast performance with optimized infrastructure designed for speed and efficiency.",
    link: "#"
  }, {
    icon: Shield,
    title: "Secure by Design",
    description: "Enterprise-grade security protocols protect your data with end-to-end encryption and compliance standards.",
    link: "#"
  }, {
    icon: Cpu,
    title: "Smart Automation",
    description: "Intelligent workflows automate repetitive tasks, freeing your team to focus on what matters most.",
    link: "#"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="key-features" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`group bg-surface border border-border rounded-[var(--radius-sm)] p-8 
                  transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
                  hover:bg-surface/95 hover:shadow-medium hover:-translate-y-2
                  ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: visibilities[i] ? `${i * 100}ms` : "0ms"
          }}>
                <div className="flex flex-col gap-6">
                  <div className="inline-flex">
                    <Icon className="text-primary transition-colors duration-[var(--duration-fast)]" size={40} strokeWidth={1.5} />
                  </div>

                  <div className="flex flex-col gap-3">
                    <h3 className="text-[22px] font-semibold text-foreground leading-[1.5]">
                      {feature.title}
                    </h3>
                    <p className="text-[16px] text-muted-foreground leading-[1.6]">
                      {feature.description}
                    </p>
                  </div>

                  <Link to={feature.link} className="inline-flex items-center text-[14px] font-semibold text-accent-dark mt-2
                      relative after:absolute after:bottom-0 after:left-0 after:h-[2px] 
                      after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)]
                      hover:after:w-full">
                    Learn more →
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}